import { useForm } from '@mantine/form';
import { mergeWith } from 'lodash';

import { useUpdateTransit } from '@hooks/transit';
import { TransitViewDocumentsFormValues } from './validateTransitViewDocumentsForm';

export const useTransitViewDocumentsFormInitializer = ({ transit }) => {
  const updateTransitMutation = useUpdateTransit();

  const buildFormValues = (t) => ({
    documents: {
      PreviousDocument: (t.Consignment.PreviousDocument || []).map((previousDocument) => ({
        type: previousDocument.type || '',
        referenceNumber: previousDocument.referenceNumber || '',
        complementOfInformation: previousDocument.complementOfInformation || '',
      })),
      SupportingDocument: (t.Consignment.SupportingDocument || []).map((previousDocument) => ({
        type: previousDocument.type || '',
        referenceNumber: previousDocument.referenceNumber || '',
        documentLineItemNumber: previousDocument.documentLineItemNumber || '',
        complementOfInformation: previousDocument.complementOfInformation || '',
      })),
      TransportDocument: (t.Consignment.TransportDocument || []).map((previousDocument) => ({
        type: previousDocument.type || '',
        referenceNumber: previousDocument.referenceNumber || '',
      })),
      AdditionalReference: (t.Consignment.AdditionalReference || []).map((previousDocument) => ({
        type: previousDocument.type || '',
        referenceNumber: previousDocument.referenceNumber || '',
      })),
      AdditionalInformation: (t.Consignment.AdditionalInformation || []).map((previousDocument) => ({
        code: previousDocument.code || '',
        text: previousDocument.text || '',
      })),
    },
  });

  const form = useForm<TransitViewDocumentsFormValues>({
    initialValues: buildFormValues(transit),
  });

  const onSubmit = async (values) => {
    updateTransitMutation.mutate({
      transit: mergeWith({ _id: transit._id }, { Consignment: { ...values.documents } }, (objValue, srcValue) =>
        Array.isArray(srcValue) ? srcValue : undefined,
      ),
    });

    form.resetDirty({});
  };

  return { form, onSubmit, buildFormValues };
};
